export default __webpack_public_path__ + "static/media/mahindra.641564ae.svg";